<template>
  <div class="jdTempsBg" @click.stop>
    <div class="jdTempsScroll pa" @click.stop>
      <div class="jdTemps bg_fff" @click.stop>
        <div class="head clearfix">
          <div class="title fl f_24 color_40 font_w_b">请选择职位类别</div>
          <div class="text fl f_14 color_90">请根据对应的行业，选择你想招的职业</div>
          <div class="close fr iconfont iconcha color_9c cursor_p" @click.stop="updateSelectProfessionState(false)"></div>
        </div>
        <div class="content pr">
          <div class="left pa">
            <div class="search">
              <!-- 智能联想 -->
              <el-autocomplete class="searchJdTemps f_14 color_40" popper-class="searchJdTempsAutocomplete"
                :maxlength="50" placeholder="搜索职位" v-model="jdTempsValue" :fetch-suggestions="jdTempsSearch"
                @select="clickLevel3" @blur="jdTempsBlur">
                <template slot-scope="{item}">
                  <div class="item" v-if="item.id!==-1">
                    <div class="title" v-html="item.level3"></div>
                    <div class="name" v-html="item.name"></div>
                  </div>
                  <div class="emptyState" v-else>暂无数据 </div>
                </template>
              </el-autocomplete>
            </div>
            <div class="list pa">
              <template v-for="(item,index) in selectProfessionList">
                <div class="item cursor_p f_16 pr transition_2" :key="String(index)"
                  :class="ProfessionSelect.level1 === item.title?'active color_40 bg_fff':'color_90'" @click="toggleLevel1(item)">{{item.title}}
                </div>
              </template>
            </div>
          </div>
          <div class="right">
            <template v-for="(item,index) in selectProfessionList">
              <div class="list" v-if="ProfessionSelect.level1 === item.title" :key="String(index)">
                <template v-for="(sitem,sindex) in item.level2List">
                  <div class="list1" :key="String(sindex)">
                    <div class="clearfix">
                      <div class="level2 fl cursor_p transition_2" :class="ProfessionSelect.level2 === ssitem.title?'active':''" v-for="(ssitem,ssindex) in sitem" :key="String(ssindex)"  @click="toggleLevel2(ssitem,ssindex,sindex)">
                        <div class="title color_0 f_14">{{ssitem.title}}</div>
                        <div class="text color_a6 f_12">{{ssitem.list.length ? ssitem.list[0].title : ''}}等 {{ssitem.list.length}} 个职位类别</div>
                      </div>
                    </div>
                    <div class="level3list clearfix" v-if="ProfessionSelect.level2ListIndex===sindex &&ProfessionSelect.level2ItemIndex!=='' && sitem[ProfessionSelect.level2ItemIndex]">
                      <div class="level3Name fl color_9c f_14 cursor_p transition_2 ellipsis width33" :class="ssitem.title===ProfessionSelect.level3?'color_blue':''" v-for="(ssitem,ssindex) in sitem[ProfessionSelect.level2ItemIndex].list" :key="String(ssindex)" @click="clickLevel3(ssitem)">
                        {{ssitem.title}}
                         <img class="hot-job" v-if="hotJobs[ssitem.profession_id]" src="https://files.wondercv.com/b-pc/fire.png" alt="">
<!--                        <img class="hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="">-->
                      </div>
                    </div>

                  </div>
                </template>
              </div>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 所有接口
  import actions from '@/actions/index'
  import  hotJobPro  from '@/assets/js/constant.js'
  import {
    mapState,
    mapMutations
  } from 'vuex'

  export default {
    name: 'SelectProfession',
    props: {
      selectProfessionList:{ //列表数据
        type:Array,
        default:()=>[]
      }
    },
    data() {
      return {
        ProfessionSelect:{ //选中状态
          level1:'',
          level2:'',
          level3:'',
          level2ListIndex:'',
          level2ItemIndex:'',
        },
        jdTempsValue:'',//搜索关键词
        jdTempsList:[],//搜索列表
        hotJobs: hotJobPro.hotJobProfessionIds
      }
    },
    created(){
      this.ProfessionSelect = JSON.parse(JSON.stringify(this.professionSelect));
    },
    mounted() {},
    computed: {
      ...mapState('jobEdit', ['professionSelect', 'profession_id', 'selectProfessionState']),
    },
    methods: {
      ...mapMutations('jobEdit', ['updateProfessionSelect', 'updateProfessionId', 'updateSelectProfessionState', 'updateUserToggleProfession']),
      //切换一级标题
      toggleLevel1(item){
        if(item.title !== this.updateProfessionSelect.level1){
          this.ProfessionSelect = {
            level1:item.title,
            level2:'',
            level3:'',
            level2ListIndex:'',
            level2ItemIndex:'',
          }
        }
      },
      //切换二级标题
      toggleLevel2(item,index, sindex){
        if(item.title !== this.ProfessionSelect.level2){
          this.ProfessionSelect.level2 = item.title;
          this.ProfessionSelect.level2ListIndex = sindex;
          this.ProfessionSelect.level2ItemIndex = index;
          // console.log(this.ProfessionSelect)
          // this.updateProfessionSelect(this.professionSelect)
        }
      },
      //点击三级
      clickLevel3(item){
        if(item.id === -1){
          return false;
        }
        let { title, level3, profession_id } = item;
        level3 = level3?level3.split(`<span class='color_blue'>`).join('').split(`</span>`).join(''):'';
        this.ProfessionSelect.level3 = title||level3;
        //同步文案
        this.updateProfessionSelect(this.ProfessionSelect);
        //同步id
        this.updateProfessionId(profession_id);
        //关闭弹窗
        this.updateSelectProfessionState(false);
        //更新用户是否切换过职位类型
        this.updateUserToggleProfession(true);
      },
      //【搜索】搜索公司名称
      jdTempsSearch(queryString, cb) {
        //搜索词一致，不进行搜索
        this.jdTempsList = [];
        this.jdTempsValue = queryString ? queryString.trim() : '';
        cb([]);
        if(!this.jdTempsValue.length){
          return false;
        }
        actions.jd_temps.search_jd_temp({name: queryString,	type:'pc' }).then(res=>{
          if(res.code === 1000){
            let { jd_temps } = res.data;
            jd_temps.forEach(item=>{
              item.level3 = this.highlightHtml(item.level3, queryString);
              let level1 = this.highlightHtml(item.level1, queryString);
              let level2 = this.highlightHtml(item.level2, queryString);
              let name = this.highlightHtml(item.name, queryString);
              item.name = `${level1} - ${level2}`;
            })
            this.jdTempsList = JSON.parse(JSON.stringify(jd_temps));
            // 调用 callback 返回建议列表的数据
            if(jd_temps.length){
              cb([...jd_temps]);
            }else{
              cb([{
                id:-1,
              }])
            }

          }
        })

      },
      //【搜索】失焦
      jdTempsBlur(){
        this.jdTempsList = [];
        this.jdTempsValue = '';
      },
      highlightHtml(text,searchValue){
        //搜索词转小写
        searchValue = searchValue.toLowerCase();
        // 标题转小写
        let textLowerCases = text.toLowerCase().split(searchValue);
        let highlightHtml = "";
        let newText = '';
        if(text.toLowerCase() === searchValue.toLowerCase()){
          return `<span class='color_blue'>${text}</span>`
        }
        textLowerCases.forEach((item,index)=>{
          if(item===''){
            let Text = text.substring(newText.length<1?0:newText.length,searchValue.length)
            highlightHtml += `<span class='color_blue'>${searchValue}</span>`
          }else{
            highlightHtml += item
          }
        })

        return highlightHtml
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../views/talent/jdTemps/Index.scss';
  .jdTempsBg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: rgba($color: #000, $alpha: 0.4);
    .jdTempsScroll{
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      transform: translate(-50%, -50%);
      margin: 0;
      width: 886px;
      overflow-y: hidden;
      overflow-x: auto;
    }
    .jdTemps {
      width: 886px;
      margin: 0 auto;
      .head{
        .title{
          padding: 0 0 0 30px;
          width: 252px;
          box-sizing: border-box;
        }
        .close{
          padding: 0 4px;
          margin-right: 45px;
          font-size: 14px;
        }
      }
      .content{
        height: 624px;
        min-height: auto;
        max-height: 80vh;
        padding-left: 252px;
        .left{
          .list{
            width: 100%;
            left: 0;
            top: 64px;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
          }
        }
        .right{
          min-height: auto;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          .list{
            padding:16px 0 32px 0
          }
          .level3list{
            width: 584px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .hot-job {
    display: inline-block;
    width: 11px;
    margin-bottom: -1px;
  }
  @media screen and (max-width: 1000px) {
    .jdTempsScroll {
      width: 94% !important;
    }
  }
</style>
